<template>
  <span class="svg-ico-circle">
    <svg v-if="isTwoTone" :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.8828 3.7168C7.92381 3.7168 3.88281 7.7578 3.88281 12.7168C3.88281 17.6758 7.92381 21.7168 12.8828 21.7168C17.8418 21.7168 21.8828 17.6758 21.8828 12.7168C21.8828 7.7578 17.8418 3.7168 12.8828 3.7168Z" :fill="color"/>
    </svg>
    <svg v-else-if="isSolid" :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.8828 3.7168C7.92381 3.7168 3.88281 7.7578 3.88281 12.7168C3.88281 17.6758 7.92381 21.7168 12.8828 21.7168C17.8418 21.7168 21.8828 17.6758 21.8828 12.7168C21.8828 7.7578 17.8418 3.7168 12.8828 3.7168Z" :fill="color"/>
    </svg>
    <svg v-else :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8828 5.15625C8.75224 5.15625 5.38281 8.52568 5.38281 12.6562C5.38281 16.7868 8.75224 20.1562 12.8828 20.1562C17.0134 20.1562 20.3828 16.7868 20.3828 12.6562C20.3828 8.52568 17.0134 5.15625 12.8828 5.15625ZM3.88281 12.6562C3.88281 7.69725 7.92381 3.65625 12.8828 3.65625C17.8418 3.65625 21.8828 7.69725 21.8828 12.6562C21.8828 17.6152 17.8418 21.6562 12.8828 21.6562C7.92381 21.6562 3.88281 17.6152 3.88281 12.6562Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default: '#E0E3E6' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
